import typogr from 'typogr';

export const widont = (html) => {
  return typogr(html).widont();
};

export const stripTags = (input) => {
  return input.replace(/<\/?[^>]+(>|$)/g, '');
}